import { Navigate, Route, Routes } from "react-router-dom";
import PageLayout from "../Layout/PageLayout";
import CheckInAddEdit from "../Pages/ASN/Check-In/CheckInAddEdit";
import CheckInDescription from "../Pages/ASN/Check-In/CheckInDetails";
import CheckInOverview from "../Pages/ASN/Check-In/CheckInOverview";
import AsnOverview from "../Pages/ASN/Overview/AsnOverview";
import AsnOverviewAddEdit from "../Pages/ASN/Overview/AsnOverviewAddEdit";
import OverviewDetails from "../Pages/ASN/Overview/OverviewDetails";
import AddPutaway from "../Pages/ASN/Putaway/AddPutaway";
import PutawayDetails from "../Pages/ASN/Putaway/PutawayDetails";
import PutawayOverview from "../Pages/ASN/Putaway/PutawayOverview";
import ReceiveDetails from "../Pages/ASN/Receive/ReceiveDetails";
import ReceiveOverview from "../Pages/ASN/Receive/ReceiveOverview";
import ReturnCheckInAddEdit from "../Pages/ASN/Return/CheckIn/ReturnCheckInAddEdit";
import ReturnCheckInDetails from "../Pages/ASN/Return/CheckIn/ReturnCheckInDetails";
import ReturnCheckinOverview from "../Pages/ASN/Return/CheckIn/ReturnCheckinOverview";
import OverviewAdd from "../Pages/ASN/Return/Overview/OverviewAdd";
import ReturnOverview from "../Pages/ASN/Return/Overview/ReturnOverview";
import ReturnsOverviewDetails from "../Pages/ASN/Return/Overview/ReturnsOverviewDetails";
import ReturnAddEditPutaway from "../Pages/ASN/Return/Putaway/ReturnAddEditPutaway";
import ReturnPutawayDetails from "../Pages/ASN/Return/Putaway/ReturnPutawayDetails";
import ReturnPutawayOverview from "../Pages/ASN/Return/Putaway/ReturnPutawayOverview";
import ReturnReceiveAddEdit from "../Pages/ASN/Return/Receive/ReturnReceiveAddEdit";
import ReturnReceiveDetails from "../Pages/ASN/Return/Receive/ReturnReceiveDetails";
import ReturnReceiveOverview from "../Pages/ASN/Return/Receive/ReturnReceiveOverview";
import ReturnAddUnload from "../Pages/ASN/Return/Unload/ReturnAddUnload";
import ReturnUnloadDetails from "../Pages/ASN/Return/Unload/ReturnUnloadDetails";
import ReturnUnloadOverview from "../Pages/ASN/Return/Unload/ReturnUnloadOverview";
import AddUnload from "../Pages/ASN/Unload/AddUnload";
import UnloadDetails from "../Pages/ASN/Unload/UnloadDetails";
import UnloadOverview from "../Pages/ASN/Unload/UnloadOverview";
import BlankPage from "../Pages/WildCardPages/BlankPage";
import ClientAddEdit from "../Pages/Client/ClientAddEdit";
import ClientDetails from "../Pages/Client/ClientDetails";
import ClientOverview from "../Pages/Client/ClientOverview";
import AccountAddEdit from "../Pages/CompanyAccount/AccountAddEdit";
import CompanyAccountDetails from "../Pages/CompanyAccount/CompanyAccountDetails";
import CustomerAddEdit from "../Pages/Customer/CustomerAddEdit";
import CustomerOverview from "../Pages/Customer/CustomerOverview";
import Error from "../Pages/Error/Error";
import AdjustmentDetails from "../Pages/Inventory/Adjustment/AdjustmentDetails";
import AdjustmentOverview from "../Pages/Inventory/Adjustment/AdjustmentOverview";
import AdjustmentCreate from "../Pages/Inventory/Adjustment/AdjustmentCreate";
import KitOrderDetails from "../Pages/Inventory/Assembly/KitOrderDetails";
import KitOrdersOverview from "../Pages/Inventory/Assembly/KitOrdersOverview";
import CycleCountByItem from "../Pages/Inventory/Counts/CycleCountByItem";
import CycleCountByLocation from "../Pages/Inventory/Counts/CycleCountByLocation";
import CycleCountDetails from "../Pages/Inventory/Counts/CycleCountDetails";
import CycleCountOverview from "../Pages/Inventory/Counts/CycleCountOverview";
import InventoryDetails from "../Pages/Inventory/Overview/InventoryDetails";
import InventoryOverview from "../Pages/Inventory/Overview/InventoryOverview";
import OverviewQtyExp from "../Pages/Inventory/Overview/OverviewQtyExp";
import ReplenishmentCreate from "../Pages/Inventory/Replenishment/ReplenishmentCreate";
import ReplenishmentDetails from "../Pages/Inventory/Replenishment/ReplenishmentDetails";
import ReplenishmentEdit from "../Pages/Inventory/Replenishment/ReplenishmentEdit";
import ReplenishmentOverview from "../Pages/Inventory/Replenishment/ReplenishmentOverview";
import StatusDetails from "../Pages/Inventory/Status/StatusDetails";
import StatusOverview from "../Pages/Inventory/Status/StatusOverview";
import TransferByItem from "../Pages/Inventory/StocksTransfer/TransferByItem";
import TransferByLocation from "../Pages/Inventory/StocksTransfer/TransferByLocation";
import TransferDetails from "../Pages/Inventory/StocksTransfer/TransferDetails";
import TransferEdit from "../Pages/Inventory/StocksTransfer/TransferEdit";
import TransferOverview from "../Pages/Inventory/StocksTransfer/TransferOverview";
import ItemsAddEdit from "../Pages/Items/ItemsAddEdit";
import ItemsOverview from "../Pages/Items/ItemsOverview";
import UserLogin from "../Pages/Login/UserLogin";
import PurchaseOrderDetails from "../Pages/PurchaseOrder/PurchaseOrderDetails";
import PurchaseOrderOverview from "../Pages/PurchaseOrder/PurchaseOrderOverview";
import RoleOverview from "../Pages/Roles/RoleOverview";
import SupplierDetails from "../Pages/Suppliers/SupplierDetails";
import SuppliersAddEdit from "../Pages/Suppliers/SuppliersAddEdit";
import SuppliersOverview from "../Pages/Suppliers/SuppliersOverview";
import BomMaintenanceOverview from "../Pages/Inventory/Assembly/BomMaintenanceOverview";
import BomMaintenanceCreate from "../Pages/Inventory/Assembly/BomMaintenanaceCreate";
import BomMaintenanceDetails from "../Pages/Inventory/Assembly/BomMaintenanceDetails";
import BomBasicInfo from "../Pages/Inventory/Assembly/BomBasicInfo";
import BomConfigureKitDetailsEdit from "../Pages/Inventory/Assembly/BomConfigureKitDetailsEdit";
import BomMaintenanceUserDefinedDetailsEdit from "../Pages/Inventory/Assembly/BomMaintenanceUserDefinedDetailsEdit";
import BomAttributeEdit from "../Pages/Inventory/Assembly/BomAttributeEdit";
import PrivateRoute from "./PrivateRoute";
import ReceiveCreate from "../Pages/ASN/Receive/ReceiveCreate";
import OutboundDetails from "../Pages/Outbound/Orders/OrderDetails";
import OutboundOverview from "../Pages/Outbound/Orders/OrderOverview";
// import AllocationPlan from "../Pages/Outbound/Allocation/AllocationPlan";
import PickPlanOverview from "../Pages/Outbound/PickPlan/Overview/PickPlanOverview";
import PickPlanDetails from "../Pages/Outbound/PickPlan/Overview/PickPlanDetails";
import FailedOrders from "../Pages/Outbound/Orders/FailedOrders";
import ErrorPage from "../Pages/Error/ErrorPage";
import ComapnyAccountOverview from "../Pages/CompanyAccount/CompanyAccountOverview";
import PageInProgress from "../Pages/WildCardPages/PageInProgress";
import CustomerDetails from "../Pages/Customer/CustomerDetails";
import ItemsDetails from "../Pages/Items/ItemsDetails";
import TemplatesOverview from "../Pages/Outbound/PickPlan/PickPlanTemplates/TemplatesOverview";
import TemplatesDetails from "../Pages/Outbound/PickPlan/PickPlanTemplates/TemplatesDetails";
import TemplatesAddEdit from "../Pages/Outbound/PickPlan/PickPlanTemplates/TemplatesAddEdit";
import ShipmentsOverview from "../Pages/Outbound/Shipments/ShipmentsOverview";
import ShipmentsDetails from "../Pages/Outbound/Shipments/ShipmentsDetails";
import PickOverview from "../Pages/Outbound/Pick/PickOverview";
import PickPlanAddEdit from "../Pages/Outbound/PickPlan/Overview/PickPlanAddEdit";
import PackOverview from "../Pages/Outbound/Pack/PackOverview";
import PickDetails from "../Pages/Outbound/Pick/PickDetails";
import PackDetails from "../Pages/Outbound/Pack/PackDetails";
import ShipOverview from "../Pages/Outbound/Ship/ShipOverview";
// import OrderEntry from "../Pages/Outbound/Orders/OrderEntry";
import OrderPickTicketDetail from "../Pages/Outbound/Orders/OrderPickTicketDetail";
import OrderShipmentDetail from "../Pages/Outbound/Orders/OrderShipmentDetail";
import OrderAddEdit from "../Pages/Outbound/Orders/OrderAddEdit";
import InventoryStatusOverview from "../Pages/InventoryStatus/InventoryStatusOverview";
import AllocationPlanOverview from "../Pages/Outbound/Allocation/Overview/AllocationPlanOverview";
import AllocationPlanAddEdit from "../Pages/Outbound/Allocation/Overview/AllocationPlanAddEdit";
import AllocationPlanDetail from "../Pages/Outbound/Allocation/Overview/AllocationPlanDetail";



const RouteNavigator = () => {
  return (
    <>
         {/* <ErrorBoundary
        fallback={<ErrorPage/>}
        
        onError={errorHandler}
      > */}
      <Routes>
        {/* Public Route List */}
        <Route path="/login" element={<UserLogin />} />
        <Route path="/error" element={<ErrorPage />} />
        
        {/* Private Routes wrapped in PageLayout */}
        <Route element={<PrivateRoute />}>
          <Route element={<PageLayout />}>
          
            {/* redirect to landing page on / */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            
            
            {/* Main Menu Routes */}
            <Route path="/dashboard" element = {<PageInProgress/>}/>
            <Route path="/inbound" element={<BlankPage />} />
            <Route path="/outbound" element={<BlankPage />} />
            <Route path="/inventory" element={<BlankPage />} />
            <Route path="/account" element={<BlankPage />} />
            <Route path="/inquiry" element={<BlankPage />} />

            {/* ASN Routes */}
            <Route path="/inbound/asn/checkin" element={<CheckInOverview />} />
            <Route path="/inbound/asn/checkin/add" element={<CheckInAddEdit />} />
            <Route path="/inbound/asn/checkin/details/:id" element={<CheckInDescription />} />
            <Route path="/inbound/asn/overview" element={<AsnOverview />} />
            <Route path="/inbound/asn/overview/add" element={<AsnOverviewAddEdit />} />
            <Route path="/inbound/asn/overview/edit/:id" element={<AsnOverviewAddEdit />} />
            <Route path="/inbound/asn/overview/details/:id" element={<OverviewDetails />} />
            <Route path="/inbound/purchase-order" element={<PurchaseOrderOverview />} />
            <Route path="/inbound/purchase-order/details/:id" element={<PurchaseOrderDetails />} />
            <Route path="/inbound/asn/receive" element={<ReceiveOverview />} />
            <Route path="/inbound/asn/receive/details/:id" element={<ReceiveDetails />} />
            <Route path="/inbound/asn/receive/create/:id" element={<ReceiveCreate />} />
            <Route path="/inbound/asn/putaway" element={<PutawayOverview />} />
            <Route path="/inbound/asn/putaway/details/:id" element={<PutawayDetails />} />
            <Route path="/inbound/asn/putaway/add" element={<AddPutaway />} />
            <Route path="/inbound/asn/unload" element={<UnloadOverview />} />
            <Route path="/inbound/asn/unload/details/:id" element={<UnloadDetails />} />
            <Route path="/inbound/asn/unload/add" element={<AddUnload />} />
            <Route path="/inbound/returns/overview" element={<ReturnOverview />} />
            <Route path="/inbound/returns/overview/details/:id" element={<ReturnsOverviewDetails />} />
            <Route path="/inbound/returns/overview/add" element={<OverviewAdd />} />
            <Route path="/inbound/returns/checkin" element={<ReturnCheckinOverview />} />
            <Route path="/inbound/returns/checkin/add" element={<ReturnCheckInAddEdit />} />
            <Route path="/inbound/returns/checkin/details/:id" element={<ReturnCheckInDetails />} />
            <Route path="/inbound/returns/unload" element={<ReturnUnloadOverview />} />
            <Route path="/inbound/returns/unload/details/:id" element={<ReturnUnloadDetails />} />
            <Route path="/inbound/returns/unload/add" element={<ReturnAddUnload />} />
            <Route path="/inbound/returns/receive" element={<ReturnReceiveOverview />} />
            <Route path="/inbound/returns/receive/details/:id" element={<ReturnReceiveDetails />} />
            <Route path="/inbound/returns/receive/add" element={<ReturnReceiveAddEdit />} />
            <Route path="/inbound/returns/putaway" element={<ReturnPutawayOverview />} />
            <Route path="/inbound/returns/putaway/details/:id" element={<ReturnPutawayDetails />} />
            <Route path="/inbound/returns/putaway/add" element={<ReturnAddEditPutaway />} />

            {/* Outbound Routes */}
            <Route path="/outbound/allocations" element={<AllocationPlanOverview />} />
            <Route path="/outbound/allocations/add" element={<AllocationPlanAddEdit />} />
            <Route path="/outbound/allocations/edit/:id" element={<AllocationPlanAddEdit />} />
            <Route path="/outbound/allocations/details/:id" element={<AllocationPlanDetail />} />
            <Route path="/outbound/orders" element={<OutboundOverview />} />
            <Route path="/outbound/orders/details/:id" element={<OutboundDetails />} />
            <Route path="/outbound/orders/order-pick-details/:id" element={<OrderPickTicketDetail />} />
            <Route path="/outbound/orders/order-shipment-details/:id" element={<OrderShipmentDetail />} />
            <Route path="/outbound/orders/add" element={<OrderAddEdit />} />
            <Route path="/outbound/orders/edit/:id" element={<OrderAddEdit />} />
            <Route path="/outbound/orders/failed-orders" element={<FailedOrders />} />
            <Route path="/outbound/shipments/overview" element={<ShipmentsOverview />} />
            <Route path="/outbound/shipments/details/:id" element={<ShipmentsDetails />} />
            <Route path="/outbound/pick/overview" element={<PickOverview />} />
            <Route path="/outbound/pick/details/:id" element={<PickDetails />} />
            <Route path="/outbound/pack/overview" element={<PackOverview />} />
            <Route path="/outbound/pack/details/:id" element={<PackDetails />} />

            <Route path="/outbound/pick-plans" element={<PickPlanOverview />} />
            <Route path="/outbound/pick-plans/details/:id" element={<PickPlanDetails />} />
            <Route path="/outbound/pick-plans/add" element={<PickPlanAddEdit />} />
            <Route path="/outbound/pick-plans/edit/:id" element={<PickPlanAddEdit />} />
            {/* <Route path="/outbound/pick-plan-templates/overview" element={<TemplatesOverview />} />
            <Route path="/outbound/pick-plan-templates/details/:id" element={<TemplatesDetails />} />
            <Route path="/outbound/pick-plan-templates/overview/add" element={<TemplatesAddEdit />} />
            <Route path="/outbound/pick-plan-templates/overview/edit/:id" element={<TemplatesAddEdit />} /> */}
            {/*<Route path="/outbound/ship/overview" element={<ShipOverview />} /> */}

            {/* Account Routes */}
            <Route path="/account/client/customer/:viewtype" element={<CustomerOverview />} />
            <Route path="/account/client/customer/edit/:id" element={<CustomerAddEdit />} />
            <Route path="/account/client/customer/add" element={<CustomerAddEdit />} />
            <Route path="/account/client/customer/details/:id" element={<CustomerDetails />} />

            <Route path="/account/client/overview/:viewtype" element={<ClientOverview />} />
            {/* <Route path="/account/client/overview/view-grid" element={<ClientGridView />} /> */}
            <Route path="/account/client/overview/details/:id" element={<ClientDetails />} />
            <Route path="/account/client/overview/create/:id?" element={<ClientAddEdit />} />
            <Route path="/account/client/overview/edit/:id?" element={<ClientAddEdit />} />
            <Route path="/account/client/supplier/:viewtype" element={<SuppliersOverview />} />
            {/* <Route path="/account/client/supplier/list-view" element={<SuppliersOverview />} /> */}
            <Route path="/account/client/supplier/edit/:id?" element={<SuppliersAddEdit />} />
            <Route path="/account/client/supplier/add" element={<SuppliersAddEdit />} />
            <Route path="/account/client/supplier/details/:id" element={<SupplierDetails />} />
            <Route path="/account/client/items/add" element={<ItemsAddEdit />} />
            <Route path="/account/client/items/edit/:id" element={<ItemsAddEdit />} />
            <Route path="/account/client/items" element={<ItemsOverview />} />
            <Route path="/account/client/items/details/:id" element={<ItemsDetails />} />

            <Route path="/account/client/inventory-status" element={<InventoryStatusOverview />} />

            <Route path="/account/company-account/:viewtype" element={<ComapnyAccountOverview />} />
            {/* <Route path="/account/company-account/:viewtype" element={<AccountOverview />} /> */}
            <Route path="/account/company-account/add/" element={<AccountAddEdit />} />
            <Route path="/account/company-account/edit/:id" element={<AccountAddEdit />} />
            <Route path="/account/company-account/details/:id" element={<CompanyAccountDetails />} />
            <Route path="/account/roles/view-list" element={<RoleOverview />} />



            <Route path="/account/roles/add" element={<PageInProgress />} />
            <Route path="/account/warehouse" element={<PageInProgress />} />
            <Route path="/account/billing-codes" element={<PageInProgress />} />
            {/* <Route path="/account/client/inventory-status" element={<PageInProgress />} /> */}
            <Route path="/account/client/carrier" element={<PageInProgress />} />
            <Route path="/account/wfSetting" element={<PageInProgress />} />
            <Route path="/inbound/dashboard" element={<PageInProgress />} />
            <Route path="/outbound/dashboard" element={<PageInProgress />} />
            <Route path="/inventory/dashboard" element={<PageInProgress />} />
            <Route path="/inventory/counts/physical-inventory-count" element={<PageInProgress />} />
            <Route path="/inventory/assembly/reverse-kit-orders" element={<PageInProgress />} />
            <Route path="/account/client/inventory-status" element={<InventoryStatusOverview />} />

            {/* Inventory Routes */}
            <Route path="/inventory/overview" element={<InventoryOverview />} />
            <Route path="/inventory/overview/overview-qty-exp/:qty/:item-code" element={<OverviewQtyExp />} />
            <Route path="/inventory/overview/details/:id" element={<InventoryDetails />} />
            <Route path="/inventory/status-overview" element={<StatusOverview />} />
            <Route path="/inventory/status-overview/details/:id" element={<StatusDetails />} />
            <Route path="/inventory/stock-transfer/transfer-details/:id" element={<TransferDetails />} />
            <Route path="/inventory/stock-transfer" element={<TransferOverview />} />
            <Route path="/inventory/stock-transfer/transfer-edit/:id" element={<TransferEdit />} />
            <Route path="/inventory/stock-transfer/transfer-by-location" element={<TransferByLocation />} />
            <Route path="/inventory/stock-transfer/transfer-by-item" element={<TransferByItem />} />
            <Route path="/inventory/replenishment" element={<ReplenishmentOverview />} />
            <Route path="/inventory/replenishment/details/:id" element={<ReplenishmentDetails />} />
            <Route path="/inventory/replenishment/replenishment-edit/:id" element={<ReplenishmentEdit />} />
            <Route path="/inventory/replenishment/create" element={<ReplenishmentCreate />} />
            <Route path="/inventory/counts/cycle-count" element={<CycleCountOverview />} />
            <Route path="/inventory/counts/cycle-count/details/:id" element={<CycleCountDetails />} />
            <Route path="/inventory/counts/cycle-count/by-item" element={<CycleCountByItem />} />
            <Route path="/inventory/counts/cycle-count/by-location" element={<CycleCountByLocation />} />
            <Route path="/inventory/inventory-adjustment" element={<AdjustmentOverview />} />
            <Route path="/inventory/inventory-adjustment-history/:id" element={<AdjustmentDetails />} />
            <Route path="/inventory/inventory-adjustment/create" element={<AdjustmentCreate />} />
            <Route path="/inventory/assembly/kitting" element={<BomMaintenanceOverview />} />
            <Route path="/inventory/assembly/kitting/create" element={<BomMaintenanceCreate />} />
            <Route path="/inventory/assembly/kitting/details/:id" element={<BomMaintenanceDetails />} />
            <Route path="/inventory/assembly/kitting/bom-basic-information-edit/:id" element={<BomBasicInfo />} />
            <Route path="/inventory/assembly/kitting/bom-attribute-edit/:id" element={<BomAttributeEdit />} />
            <Route path="/inventory/assembly/kitting/bom-configure-kit-edit/:id" element={<BomConfigureKitDetailsEdit />} />
            <Route path="/inventory/assembly/kitting/bom-user-defined-field-edit/:id" element={<BomMaintenanceUserDefinedDetailsEdit />} />
            <Route path="/inventory/assembly/kit-orders" element={<KitOrdersOverview />} />
            <Route path="/inventory/assembly/kit-orders/details/:id" element={<KitOrderDetails />} />
            <Route path="*" element={<Error />} />
          </Route>
        </Route>
      </Routes>
      {/* </ErrorBoundary> */}
    </>
  );
};


export default RouteNavigator;